import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { FlashList } from '@shopify/flash-list';
import React from 'react';
import styled from 'styled-components/native';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
/**
 * Generic option selector for form fields
 *
 * Displays a bottom sheet with a list of options for the user to select from.
 * Used by FormFieldRenderer for select-type fields (fields with options array).
 */
export default function FormFieldOptionSelector({ title, value, onChange, onClose, options, }) {
    const renderItem = ({ item }) => (_jsx(OptionButton, { elementName: "form_field_option_button", onPress: () => {
            onChange(item);
            onClose();
        }, isSelected: item === value, children: _jsx(OptionText, { isSelected: item === value, children: item }) }));
    return (_jsxs(Container, { children: [_jsxs(Header, { children: [_jsx(HeaderButton, { elementName: "form_field_option_cancel_button", onPress: onClose, children: _jsx(HeaderButtonText, { children: "\uCDE8\uC18C" }) }), _jsx(HeaderTitle, { children: title }), _jsx(HeaderButton, { elementName: "form_field_option_done_button", onPress: onClose, children: _jsx(HeaderButtonText, { children: "\uC644\uB8CC" }) })] }), _jsx(ListContainer, { children: _jsx(FlashList, { data: options, renderItem: renderItem, estimatedItemSize: 50, keyExtractor: item => item }) })] }));
}
const Container = styled.View `
  background-color: ${color.white};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: 400px;
`;
const Header = styled.View `
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom-width: 1px;
  border-bottom-color: ${color.gray20};
`;
const HeaderButton = styled(SccTouchableOpacity) `
  padding: 8px;
`;
const HeaderButtonText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 16px;
  color: ${color.blue50};
`;
const HeaderTitle = styled.Text `
  font-family: ${font.pretendardBold};
  font-size: 16px;
  color: ${color.gray100};
`;
const ListContainer = styled.View `
  flex: 1;
`;
const OptionButton = styled(SccTouchableOpacity) `
  padding: 16px;
  background-color: ${props => (props.isSelected ? color.gray10 : color.white)};
`;
const OptionText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 16px;
  color: ${props => (props.isSelected ? color.blue50 : color.gray100)};
  text-align: center;
`;
